import { render, staticRenderFns } from "./AgendaAtivaCompromissoModal.vue?vue&type=template&id=c70ab048"
import script from "./AgendaAtivaCompromissoModal.vue?vue&type=script&lang=js"
export * from "./AgendaAtivaCompromissoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports